export default __webpack_public_path__ + "static/media/wallet.7c1b6c46.png";